// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"149":"0e41649a","547":"b8d0c281","906":"8c5b8fa9"}[chunkId] + ".chunk.js";
};